import { ArrowLeft } from "lucide-react";
import { ANALYTICS_EVENTS, trackEvent } from "@repo/ui/lib/analytics";
import { AskTigerSparkle } from "./AskTigerSparkle";
import { categoryViewStyles as s } from "./CategoryView.styles";
import type { CategoryViewProps } from "./CategoryView.types";
export type { CategoryId } from "./CategoryView.types";

const CATEGORIES: Record<
  import("./CategoryView.types").CategoryId,
  { label: string; description: string; prompts: string[] }
> = {
  oncall: {
    label: "On-Call Lookup",
    description: "Find who's covering",
    prompts: ["Cardiology on call now?", "Weekend on-call coverage"],
  },
  support: {
    label: "Customer Support",
    description: "Get help from TigerConnect support",
    prompts: [
      "How do I reset my password?",
      "I'm not receiving message notifications",
      "How do I add a user to my organization?",
      "Report a bug",
      "How do I update my name, title, or email?",
    ],
  },
};

export function CategoryView({ category, onBack, onSelectPrompt }: CategoryViewProps) {
  const cat = CATEGORIES[category];

  const handleSelect = (prompt: string, index: number) => {
    trackEvent(ANALYTICS_EVENTS.suggestionChipClicked, {
      source: "category_prompt",
      category,
      prompt,
      index,
    });
    onSelectPrompt(prompt);
  };

  return (
    <div className={s.root}>
      <div className={s.header}>
        <button onClick={onBack} className={s.backBtn}>
          <ArrowLeft className={s.backIcon} /> Back
        </button>
        <p className={s.title}>{cat.label}</p>
        <p className={s.description}>{cat.description}</p>
      </div>
      <div className={s.divider} />
      <div className={s.list}>
        {cat.prompts.map((prompt, index) => (
          <button key={prompt} onClick={() => handleSelect(prompt, index)} className={s.promptBtn}>
            <div className={s.promptInner}>
              <AskTigerSparkle size={12} className={s.promptIcon} />
              <p className={s.promptLabel}>{prompt}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
